import { render, staticRenderFns } from "./RegisterOrganization.vue?vue&type=template&id=484ad9a4&scoped=true&"
import script from "./RegisterOrganization.vue?vue&type=script&lang=js&"
export * from "./RegisterOrganization.vue?vue&type=script&lang=js&"
import style0 from "./RegisterOrganization.vue?vue&type=style&index=0&id=484ad9a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484ad9a4",
  null
  
)

export default component.exports